<template>
    <div
        v-if="activeTransport"
        class="connection-method-badge"
        :title="`Connection method: ${activeTransport.name}`"
    >
        {{ activeTransport.code }}
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'ConnectionMethodBadge',

    computed: {
        ...mapGetters({
            activeTransport: 'SignalRStore/GetActiveTransport'
        })
    }
}
</script>

<style scoped>
.connection-method-badge {
    position: fixed;
    bottom: 8px;
    right: 8px;
    z-index: 1000;
    padding: 2px 6px;
    font-family: monospace;
    font-size: 0.7rem;
    color: #8a8a8a;
    background: rgba(255, 255, 255, 0.85);
    border-radius: 4px;
    pointer-events: none;
}
</style>
